export const CONSTS = {
    // User Service Constants
    AUTH_LOGIN_URL                 : "api/Account/get_token",
    AUTH_REGISTER_URL              : "api/Account/register",

    // Worker Service Constants
    WORKER_SEND_REGISTER_FORM      : "api/Worker/send_registration_form_async",
    WORKER_GET                     : "api/Worker/get",
    WORKER_GET_BY_USER_NAME        : "api/Worker/get_by_user_name",
    WORKER_GET_ALL                 : "api/Worker/get_all_async",
    WORKER_UPLOAD_FILE             : "api/Worker/upload_file_async",
    WORKER_UPDATE                  : "api/Worker/update_async",
    WORKER_GET_EXTRA_BY_ID         : "api/Worker/get_with_extra",
    WORKER_SEND_NEW_PASSWORD       : "api/Worker/send_new_password_via_email",
    WORKER_REGISTER                : "api/Worker/register",

    // Worker Demander Service Constants
    WORKER_DEMANDER_GET_ALL                             : "api/WorkerDemander/get_all",
    WORKER_DEMANDER_GET_ALL_ASYNC                       : "api/WorkerDemander/get_all_async",
    WORKER_DEMANDER_SAVE_ASYNC                          : "api/WorkerDemander/save_async",
    WORKER_DEMANDER_REQUEST_A_WORK_ASYNC                : "api/WorkerDemander/request_a_work_async",
    WORKER_DEMANDER_GET_WITH_EXTRA_ASYNC                : "api/WorkerDemander/get_with_extra_async",
    WORKER_DEMANDER_GET_WORK_REQUEST_ASYNC              : "api/WorkerDemander/get_work_request_async",
    WORKER_DEMANDER_GET_UNPLANNED_WORK_REQUESTS_ASYNC   : "api/WorkerDemander/get_all_unplanned_work_requests_async",
    WORKER_DEMANDER_UPDATE_ASYNC                        : "api/WorkerDemander/update_async",
    WORKER_DEMANDER_REGISTER                            : "api/WorkerDemander/register",
    WORKER_DEMANDER_UPDATE_WORK_REQUEST_ASYNC           : "api/WorkerDemander/update_work_request_async",
   
    
    // Management Service Constants
    MANAGEMENT_GET_METEDATA_VALUES : "api/Management/get_metadata_values",
    MANAGEMENT_GET_STRINGS_VALUES : "api/Management/get_strings_by_group_async",
}
